import { ContentArea } from 'Components/shared/ContentArea';
import { SecondaryMenu } from 'Components/shared/SecondaryMenu';
import { COMMUNICATOR_ADVANCED_SETTINGS } from 'Constants/featureFlags';
import {
  ADVANCED_SETTINGS_SUBPATH,
  SETTINGS_MENU_OPTIONS,
} from 'Constants/routing';
import useFeatureFlags from 'Hooks/featureFlags/useFeatureFlags';
import { MobXProviderContext, observer } from 'mobx-react';
import { useIsSecondaryMenuVisible } from 'Modules/ui/secondaryMenu/hooks/useIsSecondaryMenuVisible';
import * as React from 'react';
import { Outlet } from 'react-router';

import { Grid } from 'semantic-ui-react';
import type { RootStoreProps } from 'Stores/RootStore.types';

export const Settings: React.FC = observer(() => {
  const { ui } = React.useContext<RootStoreProps>(MobXProviderContext);
  const isSecondaryMenuVisible = useIsSecondaryMenuVisible();
  const { [COMMUNICATOR_ADVANCED_SETTINGS]: enableAdvancedSettings } =
    useFeatureFlags([COMMUNICATOR_ADVANCED_SETTINGS]);

  const settingsMenuOptions = enableAdvancedSettings
    ? [...SETTINGS_MENU_OPTIONS, ADVANCED_SETTINGS_SUBPATH]
    : SETTINGS_MENU_OPTIONS;

  return (
    <Grid.Column
      className="settings-container semantic-flex-row"
      onClick={() => ui.setDeletePopupDisplay(false)}
    >
      {isSecondaryMenuVisible && (
        <SecondaryMenu text="Settings" options={settingsMenuOptions} />
      )}
      <ContentArea>
        <Outlet />
      </ContentArea>
    </Grid.Column>
  );
});
